import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  BizcentralAuthBootstrap,
  InvalidBizcentralConfiguration,
  loadTicketingAuthConfig,
} from "./auth/bizcentral";

const authConfig = loadTicketingAuthConfig();

function TicketingRoot() {
  if (authConfig.mode === "invalid") {
    return <InvalidBizcentralConfiguration reason={authConfig.reason} />;
  }
  if (authConfig.mode === "bizcentral") {
    return (
      <BizcentralAuthBootstrap config={authConfig}>
        {({ generation, logout, user }) => (
          <App bizcentralMode bizcentralUser={user} key={generation} onBizcentralLogout={logout} />
        )}
      </BizcentralAuthBootstrap>
    );
  }
  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TicketingRoot />
  </StrictMode>,
);
